import { Button, Space } from "antd";
import { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import CommentIcon from "../../assets/icons/CommentIcon";
import { socketService } from "../../services/socketService";
import CustomModal from "../ui/CustomModal";

type Props = {
  open: boolean;
  handleClose: () => void;
  commentId?: string;
  onLocalUpdate: (content: string, userId: string, commentId?: string) => void;
};

export default function AddCommentModal({
  open,
  handleClose,
  commentId,
  onLocalUpdate,
}: Props) {
  const [content, setContent] = useState("");
  const { id } = useParams();

  const handleSubmit = async () => {
    const authData = localStorage.getItem("ACTION-AID-ADMIN-AUTH-LOGIN");
    const userId = JSON.parse(authData || "{}")?.data?._id;

    if (!userId || !id || !content.trim()) return;

    try {
      // Update local state first
      onLocalUpdate(content, userId, commentId);

      // Then send to socket
      if (commentId) {
        socketService.sendReplyToCommunityForum(id, commentId, userId, content);
      } else {
        socketService.sendCommentToCommunityForum(id, userId, content);
      }

      setContent("");
      handleClose();
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  return (
    <CustomModal width={792} handleClose={handleClose} open={open}>
      <div className="h-[300px] overflow-auto pt-4">
        <ReactQuill
          theme="snow"
          value={content}
          onChange={setContent}
          className="h-[75%]"
        />
      </div>
      <Space className="mt-4">
        <Button
          type="primary"
          className="flex items-center gap-1"
          onClick={handleSubmit}
        >
          <span className="text-white">
            <CommentIcon />
          </span>
          <span>{commentId ? "Reply" : "Comment"}</span>
        </Button>
        <Button onClick={handleClose}>
          <span>Close</span>
        </Button>
      </Space>
    </CustomModal>
  );
}
